.group {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: var(--space-6);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.label {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
}

.value {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: baseline;
  margin: 0;
  color: var(--color-text);
  font-size: var(--text-3xl);
  font-weight: var(--weight-semibold);
  font-variant-numeric: var(--numeric);
  letter-spacing: var(--tracking-tight);
  line-height: var(--leading-tight);
}

.unit {
  color: var(--color-text-subtle);
  font-size: var(--text-lg);
  font-weight: var(--weight-regular);
}

.delta {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
}

.delta[data-tone="positive"] {
  color: var(--color-success);
}

.delta[data-tone="negative"] {
  color: var(--color-danger);
}

.hint {
  margin: 0;
  color: var(--color-text-subtle);
  font-size: var(--text-sm);
}
